
import { VueInstance, templateRef } from '@vueuse/core';
import NewsCard from 'components/UiKit/Cards/Articles.vue';
import RecipesCard from 'components/UiKit/Cards/Recipe.vue';
import { store as i18nStore } from 'plugins/i18n/store';
import { store as interfaceStore } from 'store/interface';
import { PropType, computed, defineComponent, reactive, ref, toRefs } from 'vue';


interface Data {
  swiperOptions: any
}
export default defineComponent({
  name: 'SwiperArticles',
  components: {
    NewsCard,
    RecipesCard
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    cta: {
      type: Object,
      default: null
    },
    desc: {
      type: String,
      default: '',
    },
    items: {
      type: Array as PropType<NewsItem[] | RecipeItem[]>,
      default: null,
    },
    color: {
      type: String,
      default: 'passion',
    },
    isRecipe: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const elPrev = ref<VueInstance>()
    const elNext = ref<VueInstance>()
    const elSwiper: Obj = templateRef('elSwiper')
    const i18nLocale: Koddein.Locale = i18nStore.locale as Koddein.Locale;

    const data: Data = reactive({
      swiperOptions: {
        loop: false,
        slidesPerView: 'auto',
        overflow: true,
        centeredSlides: false,
        options: {
          slidesPerView: 'auto',
          breakpoints: {
            // desktop
            1001: {
              centeredSlides: false,
            },
          },
        }
      }
    })


    return {
      elSwiper,
      elNext,
      elPrev,
      isDesktop: computed(() => interfaceStore.isLayoutDesktop),
      ...toRefs(data),
      locale: i18nLocale?.name,
    }
  }
});
